<!-- START / END -->
<h5 translate>Start</h5>
<rotec-datepicker-v2
  [darkMode]="true"
  [min]="minDate"
  [value]="startDate"
  (valueChange)="changeStartDate($event)"
></rotec-datepicker-v2>
<h5 translate>End</h5>
<rotec-datepicker-v2
  [darkMode]="true"
  [min]="startDate"
  [value]="endDate"
  (valueChange)="changeEndDate($event)"
></rotec-datepicker-v2>

<div class="scheduling-interval-options">
  <rotec-radio-row-v2
    [darkMode]="true"
    [spaceEvenly]="true"
    [options]="intervalOptionItems"
    [selected]="intervalValue"
    (selectedChange)="changeIntervalType($event)"
  ></rotec-radio-row-v2>
</div>
<!-- DAILY -->
@if (intervalValue === interval.Daily) {
  <ma-scheduling-daily
    [interval]="dailyInterval"
    (intervalChange)="changeDailyInterval($event)"
  ></ma-scheduling-daily>
}
<!-- WEEKLY -->
@if (intervalValue === interval.Weekly) {
  <ma-scheduling-weekly
    [scheduling]="weeklyScheduling"
    (schedulingChange)="changeWeeklyScheduling($event)"
  ></ma-scheduling-weekly>
}
<!-- MONTHLY -->
@if (intervalValue === interval.Monthly) {
  <ma-scheduling-monthly
    [scheduling]="monthlyScheduling"
    (schedulingChange)="changeMonthlyScheduling($event)"
  ></ma-scheduling-monthly>
}
<!-- YEARLY -->
@if (intervalValue === interval.Yearly) {
  <ma-scheduling-yearly
    [scheduling]="yearlyScheduling"
    (schedulingChange)="changeYearlyScheduling($event)"
  ></ma-scheduling-yearly>
}
